/* eslint-disable max-len */
export const survey = {
  questionnaire: 'Հարցաթերթիկ',
  survey: 'Հարցումների անցկացում',
  question: 'Հարց',
  'survey-finished': 'Հարցումն ավարտված է։ Շնորհակալությո՛ւն',
  'answers-successfuly-sent': 'Հարցումն ավարտված է։ Շնորհակալությո՛ւն',
  'to-next-stage': 'Անցնել հաջորդ փուլին',
  'nth-question-from-x': 'Հարց {current}՝ {total}-ից',
  'response-time': 'Պատասխանի համար հատկացված ժամանակ',
  'finish-questionnaire': 'Ավարտել հարցաթերթիկը',
  'next-question': 'Հաջորդ հարցը',
  'video-interview': 'Տեսահարցազրույց',
  'selection-stages': 'Ընտրության փուլերը',
  'start-interview-notice': 'Տեսահարցազրույց անցնելու համար անհրաժեշտ է տեսաձայնագրել հարցերի պատասխանները։ Հարցերը կարող են տրվել տեքստային կամ տեսանյութի ձևաչափով։ Տեսաձայնագրման համար կպահանջվի տեսախցիկով և խոսափողով համակարգիչ, սմարթֆոն կամ պլանշետ։',
};
